import Route from '@ember/routing/route';

export default class VouchersRoute extends Route {
  // Clear per-visit gift state so a repeat voucher purchase does not inherit the
  // previous recipient/message/style (maint 5.6 leak fix).
  resetController(controller, isExiting) {
    if (isExiting) {
      controller.set('giftSelected', null);
      controller.set('gift_message', null);
      controller.set('gift_to', null);
      controller.set('gift_style', null);
    }
  }
}
